import type { ToolGroup } from '@/services/Tools';

/** Follows a support flow: find info, check the account, act, wrap up. */
export const GROUP_ORDER: ToolGroup[] = ['search', 'account', 'actions', 'conversation'];

export const GROUP_LABEL_KEY: Record<ToolGroup, string> = {
	search: 'GROUP_SEARCH',
	account: 'GROUP_ACCOUNT',
	actions: 'GROUP_ACTIONS',
	conversation: 'GROUP_CONVERSATION',
};

/** Unlisted tools fall back to their raw name rather than a made-up translation. */
export const TOOL_LABEL_KEY: Partial<Record<string, string>> = {
	search_kb: 'TOOL_SEARCH_KB',
	search_resolved_cases: 'TOOL_SEARCH_RESOLVED_CASES',
	search_antiexamples: 'TOOL_SEARCH_ANTIEXAMPLES',
	bizops_company_get: 'TOOL_BIZOPS_COMPANY_GET',
	bizops_subscription_get: 'TOOL_BIZOPS_SUBSCRIPTION_GET',
	bizops_bookings_list: 'TOOL_BIZOPS_BOOKINGS_LIST',
	bizops_messaging_quota: 'TOOL_BIZOPS_MESSAGING_QUOTA',
	release_email: 'TOOL_RELEASE_EMAIL',
	get_online_payment_link: 'TOOL_GET_ONLINE_PAYMENT_LINK',
	bizops_update_custom_trackers: 'TOOL_BIZOPS_UPDATE_CUSTOM_TRACKERS',
	handoff_to_team: 'TOOL_HANDOFF_TO_TEAM',
	close_conversation: 'TOOL_CLOSE_CONVERSATION',
	get_platform_incidents: 'TOOL_GET_PLATFORM_INCIDENTS',
};
